
import {of as observableOf,  Observable } from 'rxjs';
import {catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ISchedulingCampaigns } from './campaigns-model';
import { ErrorResponse, SuccessResponse } from '../../response';

@Injectable()
export class SchedulingCampaignsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.scheduling.baseUrl}${environment.scheduling.prefix}${SchedulingCampaignsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/campaigns';

    public scheduleMail(campaignId: string, data: ISchedulingCampaigns): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(SchedulingCampaignsService.URL + '/' + campaignId + '/schedule', data).pipe(
            catchError(x => observableOf(new ErrorResponse(x.error.messages))));
    }

}
